<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('edit_item') }}</h4>
      </div>
    </div>
    <ul class="table-top-head align-items-center">
      <li>
        <div class="page-btn edit-page-actions">
          <router-link
            v-if="showVariantDetails"
            :to="{ name: 'ItemVariants', params: { id: items.id || id } }"
            class="btn btn-added"
          >
            <span>{{ $t('view_variants') }}</span>
          </router-link>
          <router-link to="/items" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <!-- /edit -->
  <form @submit.prevent="updateItem" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div class="accordion-header" id="headingOne">
              <div class="accordion-button">
                <div class="addproduct-icon">
                  <h5><i class="ti ti-info-circle"></i><span>{{ $t('item_information') }}</span></h5>
                </div>
              </div>
            </div>
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_name') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_name"
                        class="form-control"
                      />
                      <div v-if="errors.item_name" class="text-danger mt-2">
                        <span>{{ errors.item_name }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_code"
                        class="form-control"
                      />
                      <div v-if="errors.item_code" class="text-danger mt-2">
                        <span>{{ errors.item_code }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('category') }} <span class="text-danger">*</span></label>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-modal2">
                          <i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span>
                        </a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('category', true),
                          'hide.bs.dropdown': () => setDropdownOpen('category', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedCategoryLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.category ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="cat in categories" :key="cat.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectCategory(cat)"
                            >
                              {{ cat.node }}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div v-if="errors.category" class="text-danger">{{ errors.category }}</div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('sub_category') }} <span class="text-danger">*</span></label>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#create-modal3"
                          @click="triggerFetchCategoryDetails"
                        >
                          <i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span>
                        </a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('sub_category', true),
                          'hide.bs.dropdown': () => setDropdownOpen('sub_category', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedSubCategoryLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.sub_category ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="sub in selected_cats_sub_categories" :key="sub.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectSubCategory(sub)"
                            >
                              {{ sub.node }}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div v-if="errors.sub_category" class="text-danger">{{ errors.sub_category }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('brand') }}</label>
                      <input
                        type="text"
                        v-model="items.brand"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('model_number') }}</label>
                      <input
                        type="text"
                        v-model="items.model_number"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('unit') }} <span class="text-danger">*</span></label>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-modal6">
                          <i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span>
                        </a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('unit', true),
                          'hide.bs.dropdown': () => setDropdownOpen('unit', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedUnitLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.unit ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="unit in units" :key="unit.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectUnit(unit)"
                            >
                              {{ unit.unit }}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div v-if="errors.unit" class="text-danger">{{ errors.unit }}</div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('reorder_level') }}</label>
                      <input
                        type="text"
                        v-model="items.reorder_level"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('barcode_qr_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.barcode_qr_code"
                        class="form-control"
                      />
                      <div v-if="errors.barcode_qr_code" class="text-danger">{{ errors.barcode_qr_code }}</div>
                    </div>
                  </div>

                  <div v-if="!isMultiVariant" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('discount') }}</label>
                      <input
                        type="text"
                        v-model="items.discount"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('vat_group') }} <span class="text-danger">*</span></label>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('vat_group', true),
                          'hide.bs.dropdown': () => setDropdownOpen('vat_group', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedVatGroupLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.vat_group ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="group in vat_groups" :key="group.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectVatGroup(group)"
                            >
                              {{ group.vat_group_name }}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div v-if="errors.vat_group" class="text-danger">{{ errors.vat_group }}</div>
                    </div>
                  </div>

                  <div v-if="!isMultiVariant" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('selling_price') }} <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="items.selling_price"
                        class="form-control"
                      />
                      <div v-if="errors.selling_price" class="text-danger mt-2">
                        <span>{{ errors.selling_price }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('warehouse') }} <span class="text-danger">*</span></label>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-modal1">
                          <i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span>
                        </a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('warehouse', true),
                          'hide.bs.dropdown': () => setDropdownOpen('warehouse', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedWarehouseLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.warehouse ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="warehouse in warehouses" :key="warehouse.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectWarehouse(warehouse)"
                            >
                              {{ warehouse.name }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('supplier_name') }} <span class="text-danger">*</span></label>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-modal7">
                          <i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span>
                        </a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('supplier_name', true),
                          'hide.bs.dropdown': () => setDropdownOpen('supplier_name', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedSupplierLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.supplier_name ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="supplier in suppliers" :key="supplier.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectSupplier(supplier)"
                            >
                              {{ supplier.name }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 position-relative">
                      <label class="form-label fw-semibold">{{ $t('manufacturing_date') }}</label>
                      <div class="input-group">
                        <span class="input-group-text bg-white border-end-0">
                          <i class="ti ti-calendar text-secondary"></i>
                        </span>
                        <input
                          type="date"
                          v-model="items.manufacturing_date"
                          class="form-control border-start-0"
                        />
                      </div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 position-relative">
                      <label class="form-label fw-semibold">{{ $t('expire_date') }}</label>
                      <div class="input-group">
                        <span class="input-group-text bg-white border-end-0">
                          <i class="ti ti-calendar text-secondary"></i>
                        </span>
                        <input
                          type="date"
                          v-model="items.expire_date"
                          class="form-control border-start-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div v-if="items.with_stock && !isMultiVariant" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('purchase_price') }} <span class="text-danger">*</span></label>
                      <input
                        type="text"
                        v-model="items.purchase_price"
                        class="form-control"
                      />
                      <div v-if="errors.purchase_price" class="text-danger mt-2">
                        <span>{{ errors.purchase_price }}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="items.with_stock && !isMultiVariant" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">{{ $t('stock_quantity') }}</label>
                      <!-- Read-only: stock changes only through purchase / sale / damage / return / transfer -->
                      <input
                        type="text"
                        v-model="items.stock_quantity"
                        class="form-control"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-card-one accordion" id="accordionExample3">
          <div class="accordion-item">
            <div class="accordion-header" id="headingThree">
              <div class="accordion-button">
                <div class="addproduct-icon list">
                  <h5><i class="ti ti-photo-plus"></i><span>{{ $t('images') }}</span></h5>
                </div>
              </div>
            </div>
            <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
              <div class="accordion-body">
                <div class="text-editor add-list add">
                  <div class="col-lg-12">
                    <div class="add-choosen">
                      <div class="input-blocks">
                        <div class="image-upload position-relative" style="width: 220px; height: 120px;">
                          <input
                            type="file"
                            class="form-control d-none"
                            id="imageUploadInput"
                            name="images"
                            @change="imageUpload"
                            accept="image/*"
                            multiple
                          />

                          <label
                            for="imageUploadInput"
                            class="d-flex flex-column align-items-center justify-content-center border border-primary rounded text-primary w-100 h-100"
                            style="cursor: pointer;"
                          >
                            <i class="ti ti-upload fs-1 mb-2"></i>
                            <h4 class="mb-0">{{ $t('add_images') }}</h4>
                          </label>
                        </div>
                      </div>

                      <div
                        class="phone-img"
                        v-for="(img, idx) in existingImages"
                        :key="'old-' + idx"
                      >
                        <img
                          :src="$getImageUrl(img.image)"
                          alt="existing image"
                        />
                        <a href="javascript:void(0);" @click="removeExistingImage(idx)">
                          <i class="ti ti-x"></i>
                        </a>
                      </div>

                      <div
                        class="phone-img"
                        v-for="(preview, index) in imagePreview"
                        :key="'new-' + index"
                      >
                        <img :src="preview" alt="image" />
                        <a href="javascript:void(0);" @click="removeImage(index)">
                          <i class="ti ti-x"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>

  <!-- /edit -->
  <CreateWarehouseModal
    id="create-modal1" @create_success="onWarehouseCreated"
  />

  <CreateCategoryModal
    id="create-modal2" @create_success="onCategoryCreated"
  />

  <CreateSubCategoryModal
    id="create-modal3"
    ref="createSubCategoryModal"
    :category="items.category"
    @create_success="onSubCategoryCreated"
  />

  <CreateSizeModal
    id="create-modal4" @create_success="fetchSize"
  />

  <CreateColorModal
    id="create-modal5" @create_success="fetchColor"
  />

  <CreateUnitModal
    id="create-modal6" @create_success="onUnitCreated"
  />

  <CreateSupplierModal
    id="create-modal7" @create_success="onSupplierCreated"
  />
</div>
</template>

<script>
import Modal from "@/components/common/Modal.vue";
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import CreateWarehouseModal from "@/views/admin_dashboard/item/CreateWarehouseModal.vue";
import CreateCategoryModal from "@/views/admin_dashboard/item/CreateCategoryModal.vue";
import CreateSubCategoryModal from "@/views/admin_dashboard/item/CreateSubCategoryModal.vue";
import CreateSizeModal from "@/views/admin_dashboard/item/CreateSizeModal.vue";
import CreateColorModal from "@/views/admin_dashboard/item/CreateColorModal.vue";
import CreateUnitModal from "@/views/admin_dashboard/item/CreateUnitModal.vue";
import CreateSupplierModal from "@/views/admin_dashboard/item/CreateSupplierModal.vue";
import {useToast} from "vue-toastification";


export default {
  components: {
    CreateCategoryModal,
    Modal,
    Vue3Datepicker,
    CreateWarehouseModal,
    CreateSubCategoryModal,
    CreateSizeModal,
    CreateColorModal,
    CreateUnitModal,
    CreateSupplierModal
  },

  props: ['id'],

  emits: ['create_success'],

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      dropdownOpen: {
        category: false,
        sub_category: false,
        unit: false,
        vat_group: false,
        warehouse: false,
        supplier_name: false,
      },
      items: {
        id: null, item_code: '', item_name: '', sku: '', category: null, sub_category: null, size: null, color: null,
        brand: '', model_number: '',
        warehouse: null, stock_quantity: '', unit: null, reorder_level: '', manufacturing_date: null, expire_date: null,
        item_serial_number: '', barcode_qr_code: '', supplier_name: null, purchase_price: '', selling_price: '',
        discount: '', vat_group: 0, images: [], item_type: null, with_stock: false, item_type_code: null, has_variants: false
      },
      categories: [],
      sub_categories: [],
      sizes: [],
      colors: [],
      warehouses: [],
      units: [],
      suppliers: [],
      errors: {},
      errorMessage: "",
      selected_cats_sub_categories: [],
      imagePreview: [],
      existingImages: [],
      newImages: [],
      vat_groups: [],
    };
  },

  async mounted() {
    await this.fetchDropdownData();
    await this.fetchItemData();
  },

  computed: {
    showVariantDetails() {
      return (
        this.items?.item_type_code === 'MULTI_VARIANT'
        || !!this.items?.has_variants
      );
    },

    isMultiVariant() {
      return this.items?.item_type_code === 'MULTI_VARIANT' || !!this.items?.has_variants;
    },

    selectedCategoryLabel() {
      if (!this.items.category) return this.$t('select_an_option');
      const cat = this.categories.find(
        (c) => String(c.id) === String(this.items.category)
      );
      return cat ? cat.node : this.$t('select_an_option');
    },

    selectedSubCategoryLabel() {
      if (!this.items.sub_category) return this.$t('select_an_option');
      const sub = this.selected_cats_sub_categories.find(
        (s) => String(s.id) === String(this.items.sub_category)
      );
      return sub ? sub.node : this.$t('select_an_option');
    },

    selectedUnitLabel() {
      if (!this.items.unit) return this.$t('select_an_option');
      const unit = this.units.find(
        (u) => String(u.id) === String(this.items.unit)
      );
      return unit ? unit.unit : this.$t('select_an_option');
    },

    selectedWarehouseLabel() {
      if (!this.items.warehouse) return this.$t('select_an_option');
      const warehouse = this.warehouses.find(
        (w) => String(w.id) === String(this.items.warehouse)
      );
      return warehouse ? warehouse.name : this.$t('select_an_option');
    },

    selectedSupplierLabel() {
      if (!this.items.supplier_name) return this.$t('select_an_option');
      const supplier = this.suppliers.find(
        (s) => String(s.id) === String(this.items.supplier_name)
      );
      return supplier ? supplier.name : this.$t('select_an_option');
    },

    selectedVatGroupLabel() {
      if (!this.items.vat_group && this.items.vat_group !== 0) {
        return this.$t('select_an_option');
      }
      const group = this.vat_groups.find(
        (g) => String(g.id) === String(this.items.vat_group)
      );
      return group ? group.vat_group_name : this.$t('select_an_option');
    },
  },

  watch: {
    selectedItem: {
      immediate: true,
      handler(newItem) {
        if (newItem && newItem.id) {
          this.items = { ...newItem }; // Copy selected data
        }
      },
    },
  },

  methods: {
    async fetchDropdownData() {
        try {
          const [
            categoriesRes, sub_categoriesRes, sizeRes, colorRes,
            warehouseRes, unitRes, supplierRes, vat_groupRes
          ] = await Promise.all([
            this.$axios.get(apiUrls.categories.get),
            this.$axios.get(apiUrls.sub_categories.get),
            this.$axios.get(apiUrls.item_size.get),
            this.$axios.get(apiUrls.item_color.get),
            this.$axios.get(apiUrls.inventory_warehouse.get),
            this.$axios.get(apiUrls.measurement_unit.get),
            this.$axios.get(apiUrls.inventory_supplier.get),
            this.$axios.get(apiUrls.vat_group.get)
          ]);

          this.categories = categoriesRes?.data || [];
          this.sub_categories = sub_categoriesRes?.data || [];
          this.sizes = sizeRes?.data || [];
          this.colors = colorRes?.data || [];
          this.warehouses = warehouseRes?.data || [];
          this.units = unitRes?.data || [];
          this.suppliers = supplierRes?.data || [];
          this.vat_groups = vat_groupRes?.data || [];

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

    async fetchItemData() {
      try {
        const response = await this.$axios.get(`${apiUrls.item.get}${this.id}/`);
        this.items = {
          ...this.items,
          ...response.data,
          brand: response.data.brand || '',
        };
        this.existingImages = response.data.images ? [...response.data.images] : [];

        // convert existing dates to ISO for date inputs
        this.items.manufacturing_date = this.parseToISO(this.items.manufacturing_date);
        this.items.expire_date = this.parseToISO(this.items.expire_date);

        if (this.items.category) {
          await this.fetchCatSubCategories(this.items.category);
        } else {
          this.selected_cats_sub_categories = this.sub_categories;
        }
      } catch (error) {
        this.toast.error(this.$t('error_fetching_item'));
      }
    },

    parseToISO(dateStr) {
      if (!dateStr) return null;

      const parts = dateStr.split("-");
      if (parts.length === 3) {
        let day = parts[0];
        let month = parts[1];
        let year = parts[2];

        // Convert 2-digit year to 4-digit
        if (year.length === 2) {
          year = "20" + year;
        }

        return `${year}-${month}-${day}`;
      }
      return dateStr;
    },

    async fetchWarehouse() {
      try {
        const response = await this.$axios.get(apiUrls.inventory_warehouse.get);
        this.warehouses = response.data;
      } catch (error) {

      }
    },

    async fetchCategory() {
      try {
        const response = await this.$axios.get(apiUrls.categories.get);
        this.categories = response.data;
      } catch (error) {

      }
    },

    async fetchSubCategory() {
      try {
        const response = await this.$axios.get(apiUrls.sub_categories.get);
        this.sub_categories = response.data;
      } catch (error) {

      }
    },

    async fetchSize() {
      try {
        const response = await this.$axios.get(apiUrls.item_size.get);
        this.sizes = response.data;
      } catch (error) {

      }
    },

    async fetchColor() {
      try {
        const response = await this.$axios.get(apiUrls.item_color.get);
        this.colors = response.data;
      } catch (error) {

      }
    },

    async fetchUnit() {
      try {
        const response = await this.$axios.get(apiUrls.measurement_unit.get);
        this.units = response.data;
      } catch (error) {

      }
    },

    async fetchSupplier() {
      try {
        const response = await this.$axios.get(apiUrls.inventory_supplier.get);
        this.suppliers = response.data;
      } catch (error) {

      }
    },

    async fetchVatGroup() {
      try {
        const response = await this.$axios.get(apiUrls.vat_group.get);
        this.vat_groups = response.data;
      } catch (error) {

      }
    },

    onChangeCategory(selectedValue) {
        this.fetchCatSubCategories(selectedValue.id);
      },

    async fetchCatSubCategories(categoryACCId, newSubCategoryId = null) {
      try {
        const response = await this.$axios.get(`${apiUrls.sub_categories.get}`, {
          params: { category_id: categoryACCId }
        });
        this.selected_cats_sub_categories = response.data;
        if (newSubCategoryId) {
          this.items.sub_category = newSubCategoryId;
        }
      } catch (error) {

      }
    },

    onCategoryCreated(newCat) {
      if (!newCat) return;
      const exists = this.categories.some((c) => String(c.id) === String(newCat.id));
      if (!exists) this.categories.push(newCat);
      this.$nextTick(() => this.selectCategory(newCat));
    },

    onSubCategoryCreated(categoryId, newSubId) {
      const catId = this.items.category || categoryId;
      if (catId) {
        this.fetchCatSubCategories(catId, newSubId);
      }
    },

    onUnitCreated(newUnit) {
      if (!newUnit) return;
      const exists = this.units.some((u) => String(u.id) === String(newUnit.id));
      if (!exists) this.units.push(newUnit);
      this.$nextTick(() => this.selectUnit(newUnit));
    },

    onWarehouseCreated(newWarehouse) {
      if (!newWarehouse) return;
      const exists = this.warehouses.some((w) => String(w.id) === String(newWarehouse.id));
      if (!exists) this.warehouses.push(newWarehouse);
      this.$nextTick(() => this.selectWarehouse(newWarehouse));
    },

    onSupplierCreated(newSupplier) {
      if (!newSupplier) return;
      const exists = this.suppliers.some((s) => String(s.id) === String(newSupplier.id));
      if (!exists) this.suppliers.push(newSupplier);
      this.$nextTick(() => this.selectSupplier(newSupplier));
    },

    imageUpload(event) {
      const files = event.target.files;
      if (!files || !files.length) return;

      const total = this.existingImages.length + this.newImages.length + files.length;

      if (total > 2) {
        this.toast.error(this.$t('error.max_images'));
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.newImages.push(file);

        const preview = URL.createObjectURL(file);
        this.imagePreview.push(preview);
      }
    },

    removeExistingImage(index) {
      this.existingImages.splice(index, 1);
    },

    removeImage(index) {
      this.imagePreview.splice(index, 1);
      this.newImages.splice(index, 1);
    },

    async updateItem() {
      this.errors = {};
      if (!this.items.item_code) this.errors.item_code = this.$t('error.required');
      if (!this.items.item_name) this.errors.item_name = this.$t('error.required');
      if (!this.items.unit) this.errors.unit = this.$t('error.required');
      if (!this.isMultiVariant && !this.items.selling_price && this.items.selling_price !== 0) {
        this.errors.selling_price = this.$t('error.required');
      }
      if (this.items.with_stock && !this.isMultiVariant && !this.items.purchase_price && this.items.purchase_price !== 0) {
        this.errors.purchase_price = this.$t('error.required');
      }
      if (!this.items.item_type) this.items.item_type = '';

      if (Object.keys(this.errors).length > 0) {
        const requiredMsg = this.$t('error.required');
        const hasRequired = Object.values(this.errors).some((msg) => msg === requiredMsg);
        this.toast.error(
          hasRequired
            ? 'Please fill all required fields'
            : Object.values(this.errors).join('. ')
        );
        return;
      }

      const formData = new FormData();

      // Not edited on this form / read-only display fields — omit so bad string values
      // (e.g. size/color names) never hit FK PrimaryKeyRelatedField validation.
      const skipKeys = new Set([
        'images',
        'size',
        'color',
        'size_name',
        'color_name',
        'category_name',
        'sub_category_name',
        'warehouse_name',
        'unit_name',
        'supplier_name_display',
        'vat_group_name',
        'item_type_name',
        'item_type_code',
        'has_variants',
      ]);

      // Append normal fields (skip empty so barcode stays null, not '')
      Object.keys(this.items).forEach(key => {
        if (skipKeys.has(key)) return;
        const value = this.items[key];
        if (value === null || value === undefined || value === '') return;
        formData.append(key, value);
      });

      // Send remaining existing images (after deletion)
      formData.append("existing_images", JSON.stringify(this.existingImages));

      // Send new uploaded files
      this.newImages.forEach(file => {
        formData.append("new_images[]", file);
      });

      try {
        await this.$axios.put(
          apiUrls.item.update.replace(":pk", this.items.id),
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        this.toast.success("Item successfully updated!");
        this.$router.push("/items");
        this.$emit("create_success");
        this.resetForm();

      } catch (error) {
        const data = error.response?.data;
        if (!data) {
          this.toast.error('Something went wrong');
          return;
        }

        const messages = [];
        Object.keys(data).forEach((key) => {
          const val = data[key];
          if (Array.isArray(val)) {
            val.forEach((msg) => {
              if (msg) messages.push(String(msg));
            });
          } else if (typeof val === 'string' && val.trim()) {
            messages.push(val);
          }
        });

        const uniqueMessages = [...new Set(messages)];
        this.toast.error(
          uniqueMessages.length ? uniqueMessages.join('. ') : 'Something went wrong'
        );
      }
    },

    cancelForm() {
      this.$router.push('/items');
    },

    resetForm() {
        // Reset form fields and errors
        this.items = {
          item_code: '', item_name: '', sku: '', category: '', sub_category: '', size: '', color: '', brand: '', model_number: '',
          warehouse: '', stock_quantity: '', unit: '', reorder_level: '', manufacturing_date: '', expire_date: '',
          item_serial_number: '', barcode_qr_code: '', supplier_name: '', purchase_price: '', selling_price: '', discount: '', vat_group: '', images: ''

        };
        this.errors = {};
        this.errorMessage = "";
      },

    setDropdownOpen(key, isOpen) {
      this.dropdownOpen[key] = isOpen;
    },

    selectCategory(cat) {
      this.items.sub_category = null;
      this.selected_cats_sub_categories = [];
      if (!cat) {
        this.items.category = null;
        return;
      }
      this.items.category = cat.id;
      this.fetchCatSubCategories(cat.id);
    },

    selectSubCategory(sub) {
      this.items.sub_category = sub?.id ?? null;
    },

    selectUnit(unit) {
      delete this.errors.unit;
      this.items.unit = unit?.id ?? null;
    },

    selectVatGroup(group) {
      delete this.errors.vat_group;
      this.items.vat_group = group?.id ?? null;
    },

    selectWarehouse(warehouse) {
      this.items.warehouse = warehouse?.id ?? null;
    },

    selectSupplier(supplier) {
      this.items.supplier_name = supplier?.id ?? null;
    },

    triggerFetchCategoryDetails() {
      if (this.$refs.createSubCategoryModal?.fetchCategoryDetails) {
        this.$refs.createSubCategoryModal.fetchCategoryDetails(this.items.category);
      }
    },
  },
};
</script>

<style scoped>
.edit-page-actions {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  margin-left: 0;
}

.edit-page-actions :deep(a.btn-added) {
  height: auto !important;
  width: auto !important;
  min-width: 0 !important;
  white-space: nowrap;
  padding: 8px 14px !important;
  border: none !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.form-basic-dropdown > .btn {
  gap: 0.5rem;
  min-height: 36px;
}

.form-basic-dropdown > .btn .ti {
  color: #000;
}
</style>
